<template>
  <div class="interdict" :class="`hook-${hook} layout-${layout}`">
    <div class="empty-box">
      <div class="icon"></div>
      <p v-if="!loading">{{ tip }}</p>
      <p v-else>{{ loadingTip }}</p>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Interdict',
  props: {
    tip: {
      type: String,
      default: '敬请期待！'
    },
    hook: {
      type: String,
      default: 'vh'
    },
    layout: {
      type: String,
      default: 'row'
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingTip: {
      type: String,
      default: 'loading...'
    }
  }
}
</script>

<style lang="scss" scoped>
.interdict {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .empty-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .icon {
        background-image: url('https://website.xdcdn.net/poster/58881/20250717/K833xbCX.png');
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
    }
    p {
        text-align: center;
        color: #000;
        opacity: 0.5;
    }
  }

  &.layout-column {
    .empty-box {
      width: 80%;
    }
    .icon {
      width: 100%;
      padding-top: 75%;
    }
    p {
      font-size: get_vh(18px);
    }
  }

  &.layout-row {
    &.hook-vh {
      .empty-box {
        width: get_vh(400px);
      }
      .icon {
        width: get_vh(400px);
        height: get_vh(300px);
      }
      p {
        font-size: get_vh(24px);
      }
    }
    &.hook-px {
      .empty-box {
        width: 400px;
      }
      .icon {
        width: 400px;
        height: 300px;
      }
      p {
        font-size: 24px;
      }
    }
  }
}
</style>